import { Link } from "react-router-dom";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { useTheme } from "../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";
import CondominioSelector from "./CondominioSelector";

export default function Header({ toggleSidebar }) {
  const { logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isLight    = theme === "light";
  const isContador = localStorage.getItem("rol") === "CONTADOR";

  // Direct color values — no CSS variables, no cascade issues
  const IC = isLight ? "#374151" : undefined;   // icon/text color
  const IH = isLight ? "#111827" : undefined;   // hover text (applied on hover via CSS)

  function handleLogout() { logout(); }

  function handleToggleLang() {
    const next = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
  }

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet" />

      <header>
        <nav>
          <div className="logoNav" style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
            <img src="/LOGO.png" alt="logo" width="32px" height="auto" style={{ flexShrink: 0 }} />
            <span style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 800,
              fontSize: "1.2rem",
              letterSpacing: "2px",
              lineHeight: 1,
              userSelect: "none",
              textTransform: "uppercase",
              flexShrink: 0,
            }}>
              <span style={{ color: "#f97316" }}>COR</span>
              <span style={{ color: isLight ? "#1e293b" : "#e5ecf5" }}>VANA</span>
            </span>

            {isContador && (
              <>
                {/* Separador vertical */}
                <span style={{
                  width: 1, height: 22, flexShrink: 0,
                  background: isLight ? "rgba(0,0,0,0.15)" : "rgba(255,255,255,0.12)",
                }} />
                <CondominioSelector />
              </>
            )}
          </div>

          <div className="navIcons">
            {/* Hamburger — solo visible en mobile */}
            <button
              className="nav-icon-btn nav-hamburger-btn"
              title={t("header.abrirMenu")}
              aria-label={t("header.abrirMenu")}
              onClick={toggleSidebar}
              style={{ color: IC }}
            >
              <i className="fa-solid fa-bars" style={{ color: IC }} />
            </button>

            {/* Toggle idioma */}
            <button
              className="nav-icon-btn"
              title={t("header.cambiarIdioma")}
              aria-label={t("header.cambiarIdioma")}
              onClick={handleToggleLang}
              style={{ color: IC, fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.5px" }}
            >
              {i18n.language === "es" ? "EN" : "ES"}
            </button>

            {/* Toggle tema */}
            <button
              className="nav-icon-btn"
              title={isLight ? t("header.temaOscuro") : t("header.temaClaro")}
              aria-label={isLight ? t("header.temaOscuro") : t("header.temaClaro")}
              onClick={toggleTheme}
              style={{ color: IC }}
            >
              <i className={`fa-solid ${isLight ? "fa-moon" : "fa-sun"}`} style={{ color: IC }} />
            </button>

            {/* Configuración */}
            <Link
              to="/settings"
              className="nav-icon-btn"
              title={t("header.configuracion")}
              style={{ color: IC }}
            >
              <i className="fa-solid fa-gear" style={{ color: IC }} />
            </Link>

            {/* Cerrar sesión */}
            <button
              className="nav-icon-btn nav-logout-btn"
              title={t("header.cerrarSesion")}
              aria-label={t("header.cerrarSesion")}
              onClick={handleLogout}
              style={{ color: IC }}
            >
              <i className="fa-solid fa-right-from-bracket" style={{ color: IC }} />
            </button>

            {/* Notificaciones */}
            <button
              className="nav-bell-btn"
              title={t("header.notificaciones")}
              aria-label={t("header.notificaciones")}
              style={{ color: IC }}
            >
              <i className="fa-solid fa-bell" style={{ color: IC }} />
            </button>
          </div>
        </nav>
      </header>
    </>
  );
}
